<template>
  <div class="announcement-detail">
    <main-layout>
      <div class="content-wrap">
        <div class="announcement-detail-content">
          <div class="header-title">公告详情</div>
          <div class="announcement-content">
            <div class="title">{{detail.title}}</div>
            <div class="business">尊敬的商户：</div>
            <div class="content">{{detail.content}}</div>
            <div class="platform">诺通付平台</div>
            <div class="date">{{detail.publishTime | formatDate}}</div>
          </div>
        </div>
      </div>
    </main-layout>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import MainLayout from "@/views/layout/mainlayout";
import axiosRequestNew from "@api/axiosRequestNew";

export default {
  name: "AnnouncementDetail",
  data() {
    return {
      detail: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  filters: {
    formatDate(dateStr) {
      return dateStr && dayjs(dateStr).format('YYYY年MM月DD日');
    },
  },
  methods: {
    getDetail() {
      axiosRequestNew.post('/customerNotice/queryNotice.do', {
        id: this.$route.query.id,
      }).then(({ data = {}}) => {
        this.detail = data || {};
      });
    },
  },
  components: {
    MainLayout,
  },
};
</script>
<style lang="scss" scoped>
.announcement-detail {
  .header-title {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    letter-spacing: 0;
    line-height: 20px;
    background: #F5F7FA;
    border-radius: 4px 4px 0 0;
    padding: 16px;
  }
}
.announcement-detail-content {
  background: #FFFFFF;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
.announcement-content {
  width: 610px;
  margin: 0 auto;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  line-height: 24px;
  padding: 25px 0 47px 0;
  .title {
    font-weight: bold;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    text-align: center;
  }
  .business {
    margin-top: 20px;
  }
  .platform {
    text-align: right;
    margin-top: 60px;
  }
  .content {
    margin-top: 11px;
    text-indent: 2em;
  }
  .date {
    text-align: right;
  }
}
</style>
